/*
Author: Liubo
Date: 2018-09-05
Desc: 框架配置文件
*/
const conf = {
    views: {
        home: {
            components: [{
                code: "info",
                name: "用户信息",
                component: () =>
                        import ( /* webpackChunkName: "home" */ "@/views/acctManager/orginfo.vue"),
                option: "{\"className\": \"view-border\"}"
            },
            {
                code: "assetShow",
                name: "资产信息",
                component: () =>
                        import ( /* webpackChunkName: "home" */ "@/views/assetShow/assetsInfo.vue"),
                option: "{\"className\": \"view-border\"}"
            },
            {
                code: "lists",
                name: "基金列表",
                component: () =>
                        import ( /* webpackChunkName: "home" */ "@/views/assetShow/assetsList.vue"),
                option: "{\"className\": \"view-border\"}"
            }
            ]
        },
        private: {
            components: [{
                code: "myprivate",
                name: "我的专户理财",
                component: () =>
                        import ( /* webpackChunkName: "myprivate" */ "@/views/privateFund/myPrivate.vue"),
                option: "{\"title\":\"我的专户理财\",\"className\": \"view-border\"}"
            },
            {
                code: "privateassets",
                name: "持有专户理财",
                component: () =>
                        import ( /* webpackChunkName: "privateassets" */ "@/views/privateFund/privateAssets.vue"),
                option: "{\"title\":\"持有专户理财\",\"className\": \"view-border\",\"compCate\": \"1\"}"
            }
            ]
        },
        privatefund: {
            components: [{
                code: "privatehot",
                name: "专户理财推荐",
                component: () =>
                        import ( /* webpackChunkName: "privatehot" */ "@/views/privateFund/privateHot.vue"),
                option: "{\"title\":\"专户理财推荐\",\"className\": \"\"}"
            },
            {
                code: "privatefund",
                name: "专户理财",
                component: () =>
                        import ( /* webpackChunkName: "privatefund" */ "@/views/privateFund/privateFund.vue"),
                option: "{\"title\":\"专户理财\",\"className\": \"view-border\"}"
            }
            ]
        },
        privatebuy: {
            components: [{
                code: "privatebuy",
                name: "专户理财购买",
                component: () =>
                    import ( /* webpackChunkName: "privatebuy" */ "@/views/privateFund/privateBuy.vue"),
                option: "{\"title\":\"专户理财购买\",\"className\": \"view-border\"}"
            }]
        },
        bindtransactor: {
            components: [{
                code: "bindtransactor",
                name: "绑定经办人",
                component: () =>
                    import ( /* webpackChunkName: "bindtransactor" */ "@/views/acctManager/bindtransactor.vue"),
                option: "{\"title\":\"绑定经办人\",\"className\": \"view-border\"}"
            }]

        },
        checkacct: {
            components: [{
                code: "checkacct",
                name: "完善用户信息",
                component: () =>
                    import ( /* webpackChunkName: "checkacct" */ "@/views/acctManager/checkAcct.vue"),
                option: "{\"title\":\"完善用户信息\",\"className\": \"view-border\"}"
            }]
        },
        openinfo: {
            components: [{
                code: "openinfo",
                name: "开户须知",
                component: () =>
                    import ( /* webpackChunkName: "login" */ "@/views/beforeLogin/openInfo.vue")
            }]
        },
        agentinfo: {
            components: [{
                code: "agentinfo",
                name: "经办人信息",
                component: () =>
                    import ( /* webpackChunkName: "login" */ "@/views/beforeLogin/agentInfo.vue")
            }]
        },
        orgtype: {
            components: [{
                code: "orgtype",
                name: "机构类型",
                component: () =>
                    import ( /* webpackChunkName: "login" */ "@/views/beforeLogin/orgType.vue")
            }]
        },
        basicinfo: {
            components: [{
                code: "basicinfo",
                name: "基本信息",
                component: () =>
                    import ( /* webpackChunkName: "login" */ "@/views/beforeLogin/basicInfo.vue")
            }]
        },
        orgregister: {
            components: [{
                code: "orgregister",
                name: "信息登记",
                component: () =>
                    import ( /* webpackChunkName: "login" */ "@/views/beforeLogin/orgRegister.vue")
            }]
        },
        bankinfo: {
            components: [{
                code: "bankinfo",
                name: "银行信息",
                component: () =>
                    import ( /* webpackChunkName: "login" */ "@/views/beforeLogin/bankInfo.vue")
            }]
        },
        uploadfile: {
            components: [{
                code: "uploadfile",
                name: "文件上传",
                component: () =>
                    import ( /* webpackChunkName: "login" */ "@/views/beforeLogin/uploadFile.vue")
            }]
        },
        opensuccess: {
            components: [{
                code: "opensuccess",
                name: "完成注册",
                component: () =>
                    import ( /* webpackChunkName: "login" */ "@/views/beforeLogin/openSuccess.vue")
            }]
        },
        orginfo: {
            components: [{
                code: "acctinfo",
                name: "机构用户信息",
                component: () =>
                        import ( /* webpackChunkName: "orginfo" */ "@/views/acctManager/acctInfo.vue"),
                option: "{\"className\": \"view-border\"}"
            },
            // {
            //     code: "holdbank",
            //     name: "我的银行卡",
            //     component: () =>
            //             import ( /* webpackChunkName: "orginfo" */ "@/views/bank/holdBank.vue"),
            //     option: "{\"title\":\"我的银行卡\",\"className\": \"view-border\"}"
            // },
            {
                code: "personinfo",
                name: "我的信息资料",
                component: () =>
                        import ( /* webpackChunkName: "orginfo" */ "@/views/acctManager/securityCenter.vue"),
                option: "{\"title\":\"我的信息资料\",\"className\": \"view-border\"}"
            }
            ]
        },
        modifyinfo: {
            components: [{
                code: "modifyinfo",
                name: "机构账户信息",
                component: () =>
                    import ( /* webpackChunkName: "modifyinfo" */ "@/views/acctManager/modifyInfo.vue"),
                option: "{\"title\":\"账户信息\",\"className\": \"view-border\"}"
            }]
        },
        changetpwd: {
            components: [{
                code: "changetpwd",
                name: "交易密码修改",
                component: () =>
                    import ( /* webpackChunkName: "changetpwd" */ "@/views/acctManager/changeTPwd.vue"),
                option: "{\"title\":\"交易密码修改\",\"className\": \"view-border\"}"
            }]
        },
        changelpwd: {
            components: [{
                code: "changelpwd",
                name: "登陆密码修改",
                component: () =>
                    import ( /* webpackChunkName: "changetpwd" */ "@/views/acctManager/changeLPwd.vue"),
                option: "{\"title\":\"登陆密码修改\",\"className\": \"view-border\"}"
            }]
        },
        infocollection: {
            components: [{
                code: "infocollection",
                name: "投资者信息补录",
                component: () =>
                    import ( /* webpackChunkName: "infocollection" */ "@/views/appropriatenes/infoCollection.vue"),
                option: "{\"title\":\"投资者信息补录\",\"className\": \"view-border\"}"
            }]
        },
        taxeslist: {
            components: [{
                code: "taxeslist",
                name: "机构涉税信息",
                component: () =>
                    import ( /* webpackChunkName: "taxes" */ "@/views/appropriatenes/taxesList.vue"),
                option: "{\"title\":\"机构涉税信息\",\"className\": \"view-border\"}"
            }]
        },
        taxesinfo: {
            components: [{
                code: "taxesinfo",
                name: "机构涉税信息",
                component: () =>
                    import ( /* webpackChunkName: "taxes" */ "@/views/appropriatenes/taxesInfo.vue"),
                option: "{\"title\":\"机构涉税信息\",\"className\": \"view-border\"}"
            }]
        },
        beneficiarylist: {
            components: [{
                code: "beneficiarylist",
                name: "受益人信息",
                component: () =>
                    import ( /* webpackChunkName: "taxes" */ "@/views/appropriatenes/beneficiarylist.vue"),
                option: "{\"title\":\"受益人信息\",\"className\": \"view-border\"}"
            }]
        },
        controllist: {
            components: [{
                code: "controllist",
                name: "控制人信息",
                component: () =>
                    import ( /* webpackChunkName: "taxes" */ "@/views/appropriatenes/controllist.vue"),
                option: "{\"title\":\"控制人信息\",\"className\": \"view-border\"}"
            }]
        },
        controlinfo: {
            components: [{
                code: "controlinfo",
                name: "控制人信息",
                component: () =>
                    import ( /* webpackChunkName: "taxes" */ "@/views/appropriatenes/controlinfo.vue"),
                option: "{\"title\":\"控制人信息\",\"className\": \"view-border\"}"
            }]
        },
        beneficiaryinfo: {
            components: [{
                code: "beneficiaryinfo",
                name: "受益人信息",
                component: () =>
                    import ( /* webpackChunkName: "taxes" */ "@/views/appropriatenes/beneficiaryinfo.vue"),
                option: "{\"title\":\"受益人信息\",\"className\": \"view-border\"}"
            }]
        },
        invchange: {
            components: [{
                code: "invchange",
                name: "投资者转换",
                component: () =>
                    import ( /* webpackChunkName: "invchange" */ "@/views/appropriatenes/invChange.vue"),
                option: "{\"title\":\"投资者转换\",\"className\": \"view-border\"}"
            }]
        },
        invknowledgetest: {
            components: [{
                code: "invknowledgetest",
                name: "投资者知识评测",
                component: () =>
                    import ( /* webpackChunkName: "invchange" */ "@/views/appropriatenes/invKnowledgeTest.vue"),
                option: "{\"title\":\"投资者知识评测\",\"className\": \"view-border\"}"
            }]
        },
        invdataup: {
            components: [{
                code: "invdataup",
                name: "投资者转换资料上传",
                component: () =>
                    import ( /* webpackChunkName: "invchange" */ "@/views/appropriatenes/invDataUp.vue"),
                option: "{\"title\":\"投资者转换资料上传\",\"className\": \"view-border\"}"
            }]
        },
        risk: {
            components: [{
                code: "risk",
                name: "风险测评",
                component: () =>
                    import ( /* webpackChunkName: "risk" */ "@/views/acctManager/risk.vue"),
                option: "{\"title\":\"风险测评\",\"className\": \"view-border\"}"
            }]
        },
        risktest: {
            components: [{
                code: "risktest",
                name: "风险测评试题",
                component: () =>
                    import ( /* webpackChunkName: "risktest" */ "@/views/acctManager/riskTest.vue"),
                option: "{\"title\":\"风险测评试题\",\"className\": \"view-border\"}"
            }]
        },
        statement: {
            components: [{
                code: "statement",
                name: "对账单信息",
                component: () =>
                    import ( /* webpackChunkName: "statement" */ "@/views/acctManager/statement.vue"),
                option: "{\"title\":\"对账单信息\",\"className\": \"view-border\"}"
            }]
        },
        fund: {
            components: [{
                code: "hotfund",
                name: "热门基金",
                component: () =>
                    import ( /* webpackChunkName: "hotfund" */ "@/views/fund/hotFund.vue"),
                option: "{\"title\":\"热门基金\",\"className\": \"view-border\"}"
            },
            {
                code: "fundmarket",
                name: "基金超市",
                component: () =>
                        import ( /* webpackChunkName: "fundmarket" */ "@/views/fund/fundMarket.vue"),
                option: "{\"title\":\"基金超市\",\"className\": \"view-border\"}"
            }
            ]
        },
        cfund: {
            components: [{
                code: "cfund",
                name: "基金转换",
                component: () =>
                    import ( /* webpackChunkName: "cfund" */ "@/views/fund/changeFundList.vue"),
                option: "{\"title\":\"基金转换\",\"className\": \"view-border\"}"
            }]
        },
        buyfund: {
            components: [{
                code: "buyfund",
                name: "基金购买",
                component: () =>
                    import ( /* webpackChunkName: "buyfund" */ "@/views/fund/buyFund.vue"),
                option: "{\"title\":\"基金购买\",\"className\": \"view-border\"}"
            }]
        },
        sellfund: {
            components: [{
                code: "sellfund",
                name: "基金赎回",
                component: () =>
                    import ( /* webpackChunkName: "sellfund" */ "@/views/fund/sellFund.vue"),
                option: "{\"title\":\"基金赎回\",\"className\": \"view-border\"}"
            }]
        },
        changefund: {
            components: [{
                code: "changefund",
                name: "基金转换",
                component: () =>
                    import ( /* webpackChunkName: "changefund" */ "@/views/fund/changeFund.vue"),
                option: "{\"title\":\"基金转换\",\"className\": \"view-border\"}"
            }]
        },
        traderecord: {
            components: [{
                code: "traderecord",
                name: "交易查询",
                component: () =>
                    import ( /* webpackChunkName: "traderecord" */ "@/views/infoQry/tradeRecord.vue"),
                option: "{\"title\":\"交易查询\",\"className\": \"view-border\"}"
            }]
        },
        /*acctApplication: {
            components: [{
                code: "acctApplication",
                name: "账户申请",
                component: () =>
                    import ( /!* webpackChunkName: "acctApplication" *!/ "@/views/infoQry/acctApplication.vue"),
                option: "{\"title\":\"账户查询\",\"className\": \"view-border\"}"
            }]
        },*/
        infoPublish: {
            components: [{
                code: "infoPublish",
                name: "信息披露",
                component: () =>
                    import ( /* webpackChunkName: "infoPublish" */ "@/views/infoQry/infoPublish.vue"),
                option: "{\"title\":\"信息披露\",\"className\": \"view-border\"}"
            }]
        },
        knowdetail: {
            components: [{
                code: "knowdetail",
                name: "公告详情",
                component: () =>
                    import ( /* webpackChunkName: "knowdetail" */ "@/views/infoQry/knowdetail.vue"),
                option: "{\"title\":\"公告详情\",\"className\": \"view-border\"}"
            }]
        },
        policyAndLaw: {
            components: [{
                code: "policyAndLaw",
                name: "政策法规",
                component: () =>
                    import ("@/components/policyAndLaw/policyAndLaw.vue"),
                option: "{\"title\":\"政策法规\",\"className\": \"bizcomp-border\"}"
            }]
        },
        remitinfo: {
            components: [{
                code: "remitinfo",
                name: "汇款信息",
                component: () =>
                    import ( /* webpackChunkName: "remitinfo" */ "@/views/infoQry/remitinfo.vue"),
                option: "{\"title\":\"汇款信息\",\"className\": \"view-border\"}"
            }]
        },
        dividend: {
            components: [{
                code: "dividend",
                name: "分红查询",
                component: () =>
                    import ( /* webpackChunkName: "dividend" */ "@/views/infoQry/dividend.vue"),
                option: "{\"title\":\"分红查询\",\"className\": \"view-border\"}"
            }]
        }
    }
};
export default conf;
